import type React from 'react'

import { TextBoxMaxLine1Headline3 } from 'atoms/TextBox/Templates'
import { FIXED_INDENTS } from 'vars/index'
import { PaymentOptionPopupSC } from './PopupComponents.styled'

export interface INewCardPopup {
  children?: React.ReactNode
  rowGap?: FIXED_INDENTS
  title: string
}

export const NewCardPopup = ({
  children,
  rowGap = FIXED_INDENTS.INDENT_80,
  title,
}: INewCardPopup) => {
  return (
    <PaymentOptionPopupSC rowGap={rowGap}>
      <TextBoxMaxLine1Headline3 title={title} />
      {children}
    </PaymentOptionPopupSC>
  )
}
